'use client';

import { BadgeProps } from '@vaad1st/component.atom.badge';
import {
  ContentCardComponent as ContentCard,
  ContentCardProps,
} from '@vaad1st/component.molecule.content-card';
import classnames from 'classnames';
import { checkCardBadge } from 'src/utils';
import { containsHTML } from 'src/utils/aem-utils/utils';
import { hardRedirectTo } from 'src/utils/navigation';
import { HeadingElementType } from 'src/utils/shared-types';
import HTMLRenderer from '../html-renderer/html-renderer.component';
import styles from './content-card.component.module.less';

export enum ParentComponent {
  None = 'none',
  ContentCardContainer = 'content-card-container',
  Carousel = 'carousel',
}

interface ContentCardBadgeProps extends BadgeProps {
  hideLabel?: string;
}
interface ContentCardComponentProps extends Omit<ContentCardProps, 'button'> {
  titleElement?: HeadingElementType;
  parentComponent?: ParentComponent;
  cardType?: string;
  'sling:resourceType'?: string;
  'cq:panelTitle'?: string;
  badge?: ContentCardBadgeProps | any;
  textIsRich?: boolean;
  button?: {
    href?: string;
    text?: string;
    as?: 'a' | 'button';
  };
}

export default function ContentCardComponent({
  parentComponent = ParentComponent.None,
  ...props
}: ContentCardComponentProps) {
  const cardProps = {
    ...props,
    ...(props.badge && { badge: { ...props.badge } }),
  };
  const rawHref = cardProps?.button?.href;
  const href = rawHref ?? undefined;
  const hasLink = href && href.length > 0 ? true : false;
  const hasImage =
    cardProps?.image?.url && cardProps?.image?.url.length > 0 ? true : false;

  const handleOnClick = (e: any) => {
    const className = e.target.className;
    const isImage = className.indexOf('content-card-module_image') > -1;

    if (isImage && href && hasLink && typeof window !== 'undefined') {
      hardRedirectTo(href);
    }
  };

  //? These props are not used in the ContentCard component and should be removed
  // props.cardType
  // props['sling:resourceType']
  // props.textIsRich

  delete cardProps.cardType;
  delete cardProps['sling:resourceType'];
  delete cardProps['cq:panelTitle'];
  delete cardProps.textIsRich;
  delete cardProps?.badge?.showIcon;

  checkCardBadge(cardProps);

  if (cardProps.button) {
    if (href) {
      cardProps.button = {
        ...cardProps.button,
        href,
        as: 'a',
      };
    }
  }

  // If the text prop contains HTML, render it using the HTMLRenderer component
  if (
    cardProps.hasOwnProperty('text') &&
    cardProps.text &&
    containsHTML(cardProps.text as string)
  ) {
    cardProps.text = HTMLRenderer({
      htmlString: cardProps.text as string,
    }) as any;
  }

  return (
    <div
      className={classnames(styles['content-card'], {
        [styles['content-card__parent--carousel']]:
          parentComponent === ParentComponent.Carousel,
        [styles['content-card__link-image']]: hasLink && hasImage,
      })}
      onClick={handleOnClick}>
      <ContentCard {...cardProps} />
    </div>
  );
}
